import { render } from "./HomeCarouselManagement.vue?vue&type=template&id=0c5cf7ef&scoped=true"
import script from "./HomeCarouselManagement.vue?vue&type=script&lang=js"
export * from "./HomeCarouselManagement.vue?vue&type=script&lang=js"

import "./HomeCarouselManagement.vue?vue&type=style&index=0&id=0c5cf7ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5cf7ef"]])

export default __exports__